import React from "react";
import RecallSettings from "./RecallSettings";
import RecallTimings from "./RecallTimings";

function RecallsTab() {
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
           Recalls Settings
        </h5>
        <div></div>
      </div>
        <RecallSettings/>
      <h5 className="card-title" style={{ color: "#012970" }}>
           Recalls Timings
      </h5>
      <RecallTimings/>
    </>
  );
}

export default RecallsTab;
